import { Box } from '@mui/material';
import { Controller } from 'react-hook-form';
import { EditClientStepProps } from '../../../types';
import { JSX } from 'react';
import { LegalEntity } from '../../../../common/types/client';
import AsyncFormSelect from '../../../../common/components/form/asyncFormSelect';
import NumberTextField from '../../../../common/components/form/numberTextField';

/**
 * Legal entity valuation edit form
 */
const ValuationStep = ({ control }: EditClientStepProps<LegalEntity>): JSX.Element => {
  return (
    <Box className="grid gap-8 md:grid-cols-2">
      <Controller
        name="valuation.methodID"
        control={control}
        render={({ field, fieldState: { error } }): JSX.Element => (
          <AsyncFormSelect
            {...field}
            label="Valuation method"
            error={Boolean(error)}
            optionsEndpoint="/ValuationMethods"
          />
        )}
      />
      <Controller
        name="valuation.value"
        control={control}
        render={({ field, fieldState: { error } }): JSX.Element => (
          <NumberTextField
            {...field}
            prefix="R "
            label="Business valuation"
            placeholder="e.g. 5000000"
            error={!!error}
          />
        )}
      />
      <Controller
        name="valuation.basisID"
        control={control}
        render={({ field, fieldState: { error } }): JSX.Element => (
          <AsyncFormSelect
            {...field}
            label="Valuation basis"
            error={Boolean(error)}
            optionsEndpoint="/ValuationBasiss"
          />
        )}
      />
    </Box>
  );
};

export default ValuationStep;
